export default "__VITE_ASSET__6da332b4__"